'use client';
import { createStyles, getSize, rem, responsiveSize } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const textGaps = responsiveSize(2, [
    'sm1.up',
    4
]);
const headingGaps = responsiveSize(4, [
    'sm1.up',
    6
], [
    'md1.up',
    8
]);
var useStyles = createStyles((theme, { promo }, { size, variant })=>{
    const [_, textHeight] = getSize({
        size,
        sizes: variant === 'heading' ? theme.typography.variants.heading.sizes : theme.typography.variants.text.sizes
    });
    const gap = variant === 'heading' ? headingGaps(size) : textGaps(size);
    return {
        root: _extends({
            display: 'inline-flex',
            alignItems: 'center',
            gap
        }, theme.fn.typography({
            size,
            variant,
            italic: promo,
            weight: 'semibold'
        })),
        amount: {},
        icon: {
            color: theme.palette.text.onColor,
            height: rem(textHeight / 1.25),
            width: rem(textHeight / 1.25)
        },
        circle: {
            backgroundColor: theme.palette.miles.base,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center'
        }
    };
});

export { useStyles as default };
//# sourceMappingURL=MilesRound.styles.js.map
